import { AdministrateResourceSorter } from "../../../components/AdministrateResourceSorter";
import { useUpdatePermission } from "../../../utils";

export const RankOrderTab = () => {
  const [canUpdate] = useUpdatePermission("AvailityErrorRule");

  return canUpdate ? (
    <AdministrateResourceSorter
      Label={({ item }) => `HTTP ${item.httpResponseCode || "any"} / Availity ${item.availityStatusCode || "any"}`}
      Description={({ item }) => item.messageRegex || "No message regex"}
      resourceUrl="/admin/availity_error_rules"
      resourceKey="availity_error_rule"
      updateAttribute="rule_order_position"
    />
  ) : null;
};
